<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    name: 'SurveyResult',
    mixins: [curd],
    props: ['defaultParams'],
    data() {
      return {
        url: '/survey/result',
        option: {
          menu: false,
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增文字单选', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中x
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '项目题目',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left'
            },
            {
              label: '项目类型',
              prop: 'type',
              disabled: true,
              span: 24,
              type: 'select',
              html: true,
              dicData: [{'label': '文字单选', 'value': 0}, {'label': '文字多选', 'value': 1}, {
                'label': '图片单选',
                'value': 2
              }, {'label': '题目多选', 'value': 3}, {'label': '问答题', 'value': 4}],
              formatter: function (row) {
                if (row.type === 0) return '<span style="color: #76b1f9">文字单选</span>';
                if (row.type === 1) return '<span style="color: blue">文字多选</span>';
                if (row.type === 2) return '<span style="color: yellowgreen">图片单选</span>';
                if (row.type === 3) return '<span style="color: green">图片多选</span>';
                return '问答题';
              }
            },
            {
              label: '项目图片',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              hide: true,
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '选项统计',
              prop: 'optionCount',
              formatter: function (raw) {
                let data = '';
                raw.survey_question_option.forEach(function (item, index) {
                  data += String.fromCharCode(65+index) + '：' + item.num + '人；'
                });
                return data;
              }
            }
          ]
        }
      }
    }
  }
</script>
